
const digest = 'bf1afa96877e3af1e677f0f4ecdd61929d68df913785bb2234305a1802530337';
const classes = {"wrapper":"_wrapper_n3e0f_1","iconWrapper":"_iconWrapper_n3e0f_12","title":"_title_n3e0f_19","text":"_text_n3e0f_23"};
const css = `._wrapper_n3e0f_1 {
  background: #ffffff;
  padding: 40px;
  border-radius: 25px;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_n3e0f_1 ._iconWrapper_n3e0f_12 {
  border-radius: 100%;
  height: 50px;
  width: 50px;
  padding: 10px;
  background: #d9e2ff;
}
._wrapper_n3e0f_1 ._title_n3e0f_19 {
  font-size: 20px;
  font-weight: 500;
}
._wrapper_n3e0f_1 ._text_n3e0f_23 {
  color: #424754;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  